import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
export function useOnLocationLeave(fn) {
    const { key } = useLocation();
    const fnRef = useRef(fn);
    useEffect(() => {
        fnRef.current = fn;
    }, [fn]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: we only care on location change.
    useEffect(() => {
        return () => {
            fnRef.current();
        };
    }, [key]);
}
